export type CurrencyInfo = {
  apiName: Currency
  fullName: string
  name: string
  decimals: number
  maxValue: number
}

export const currenciesArr = ['btc', 'eur', 'nok', 'sek', 'dkk', 'usd', 'cad'] as const

export type Currency = typeof currenciesArr[number]

const fiatDefault = {
  decimals: 2,
  maxValue: 999999,
}

export const currenciesInfo: Record<Currency, CurrencyInfo> = {
  btc: {
    name: 'BTC',
    apiName: 'btc',
    fullName: 'Bitcoin',
    decimals: 8,
    maxValue: 50,
  },
  eur: {
    name: 'EUR',
    apiName: 'eur',
    fullName: 'Euro',
    ...fiatDefault,
  },
  nok: {
    name: 'NOK',
    apiName: 'nok',
    fullName: 'Norwegian Krone',
    ...fiatDefault,
  },
  sek: {
    name: 'SEK',
    apiName: 'sek',
    fullName: 'Sweden Krone',
    ...fiatDefault,
  },
  dkk: {
    name: 'DKK',
    apiName: 'dkk',
    fullName: 'Denmark Krone',
    ...fiatDefault,
  },
  usd: {
    name: 'USD',
    apiName: 'usd',
    fullName: 'USA Dollar',
    ...fiatDefault,
  },
  cad: {
    name: 'CAD',
    apiName: 'cad',
    fullName: 'Canadian Dollar',
    ...fiatDefault,
  },
} as const
